import Home from './pages/Home';
import './assets/global.css';
import './assets/media.css';

function App() {
  return <Home />;
}

export default App;